import { storyblokEditable } from "@storyblok/react";

const ImageBlock = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="block-image">
      <img src={blok.imageblock.filename} alt={blok.imageblock.alt} />
    </div>
  );
};

export default ImageBlock;
